import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 512 512' className={className}>
      <path
        d='M500.678276,126.485333 L501.318276,130.666667 C495.13161,108.714667 478.42761,91.776 457.200943,85.6106667 L456.752943,85.504 C416.838276,74.6663718 256.21961,74.6663718 256.21961,74.6663718 C256.21961,74.6663718 96.0062762,74.4533333 55.6862762,85.504 C34.0542762,91.776 17.3289429,108.714667 11.2489429,130.218667 L11.1422762,130.666667 C-3.76972376,208.554667 -3.87639042,302.144 11.8036096,385.536 L11.1422762,381.312 C17.3289429,403.264 34.0329429,420.202667 55.2596096,426.368 L55.7076096,426.474667 C95.5796096,437.333333 256.240943,437.333333 256.240943,437.333333 C256.240943,437.333333 416.432943,437.333333 456.774276,426.474667 C478.42761,420.202667 495.152943,403.264 501.232943,381.76 L501.33961,381.312 C508.12361,345.088 512.006276,303.402667 512.006276,260.821333 C512.006276,259.264 512.006276,257.685333 511.984943,256.106667 C512.006276,254.656 512.006276,252.928 512.006276,251.2 C512.006276,208.597333 508.12361,166.912 500.678276,126.485333 L500.678276,126.485333 Z M204.976943,333.888 L204.976943,178.304 L338.65161,256.213333 L204.976943,333.888 Z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
